import React, { useEffect, useState, useId } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { postAPI, reinitialiseAPI } from 'store/apiReducer';
import { useHistory, useLocation } from 'react-router-dom';
import {
    Container,
    Button,
    LoaderMi,
    InputControl,
    CheckboxControl,
    FieldsetControl,
    RadioControl,
    Link,
    Row,
    Col,
} from '@si-armes/dsfr-react';
import InputFiles from 'components/Commun/Form/InputFiles';
import { getDateFormatWithSlash } from 'components/Commun/Form/maskFunctions';
import { FormProvider, useForm } from 'react-hook-form';
import { getMessageErreurChampManquant, getPatternHookFormValidation } from 'utils/utils';
import { REGEXP_DATE_FR } from 'constants/contraintes.constants';
import usagerClientReducer from 'store/usagerReducer';
import {
    API_DECLARATION_ARME_PERDUE_VOLEE_RECUPERER_URL,
    API_DECLARATION_ARME_PERDUE_VOLEE_VALIDER_URL,
    CONTEXT_DECLARATION_ARME_PERDUE_VOLEE_RECUPERER,
    CONTEXT_DECLARATION_ARME_PERDUE_VOLEE_VALIDER,
} from 'constants/apiUrls.constants';
import { MESSAGE_DATE_NAISSANCE_INVALIDE } from 'constants/messagePersonalise.constants';
import TableauArmePerdueVolee from './TableauArmePerdueVolee';
import RoutesRatelier from '../../../ratelier/routes';
import { getPath } from '../../../../../utils/router';
import InfoChampsObligatoire from '../../../../../components/form/infoObligatoire/InfoChampsObligatoire';

const FormulaireArmePerdueVolee = ({
    dataProfil,
    postApi,
    reinitialiseApi,
    message,
    erreur,
    isLoading,
    isLoadingListeArme,
    dataListeArme,
}) => {
    const { REACT_APP_CONTACT_GENDARMERIE_POLICE_URL } = process.env;
    const [listeArmesDeclarationPerduesVolees, setListeArmesDeclarationPerduesVolees] = useState(
        [],
    );
    const [isSubmitting, setIsSubmitting] = useState(false);
    const location = useLocation();
    const history = useHistory();
    const hookForm = useForm({
        mode: 'onChange',
    });
    const { handleSubmit, register, formState, watch } = hookForm;
    const { isValid } = formState;
    const reinitialiserStore = () => {
        reinitialiseApi(CONTEXT_DECLARATION_ARME_PERDUE_VOLEE_VALIDER);
        reinitialiseApi(CONTEXT_DECLARATION_ARME_PERDUE_VOLEE_RECUPERER);
    };

    const retourRatelier = () => {
        reinitialiserStore();
        history.push(getPath(RoutesRatelier));
    };

    const formaterDataJustificatif = (donnees) => {
        return donnees.justificatif[0].getFileToSend();
    };

    const supprimerArme = (index) => {
        const listeArmesDeclarationPerduesVoleesTmp = [...listeArmesDeclarationPerduesVolees];
        listeArmesDeclarationPerduesVoleesTmp.splice(index, 1);
        setListeArmesDeclarationPerduesVolees(listeArmesDeclarationPerduesVoleesTmp);
    };

    const getBoutonAction = (index) => {
        return (
            <Button
                className="fr-fi-delete-line"
                variant="primary"
                aria-hidden="true"
                onClick={() => supprimerArme(index)}
            />
        );
    };

    const hasFormValid = () => {
        return (
            watch('situation') &&
            watch('dateRecepisseDeclaration') &&
            watch('lieuRecepisseDeclaration') &&
            watch('justificatif') &&
            watch('certificationInformation') &&
            isValid
        );
    };

    useEffect(() => {
        if (dataListeArme) {
            const listeArme = dataListeArme.map((element) => ({
                numeroEncodage: element.numeroEncodage,
                numeroCarcasse: element.numeroCarcasse,
                type: element.type,
                marque: element.marque,
                modele: element.modele,
                calibreCanon: element.calibreCanon,
                calibreCanonDeux: element.calibreCanonDeux,
                classement: element.classement,
                statut: element.statut,
                uniquid: element.uniquid,
            }));
            setListeArmesDeclarationPerduesVolees(listeArme);
        }
    }, [dataListeArme]);

    const onSubmit = (donnees) => {
        setIsSubmitting(true);
        const dataToSend = donnees;
        dataToSend.listeArmes = listeArmesDeclarationPerduesVolees.map(
            (element) => element.uniquid,
        );

        // afficher une erreur si situation n'est pas selectionné
        const donneePJ = formaterDataJustificatif(dataToSend);

        donneePJ.then((value) => {
            dataToSend.justificatif = { contenu: value.contenu, libelle: value.filename };
            postApi(
                usagerClientReducer,
                API_DECLARATION_ARME_PERDUE_VOLEE_VALIDER_URL,
                dataToSend,
                CONTEXT_DECLARATION_ARME_PERDUE_VOLEE_VALIDER,
            );
        });
    };

    useEffect(() => {
        if (message && !erreur) {
            setIsSubmitting(false);
            retourRatelier();
        } else if (erreur) {
            setIsSubmitting(false);
        }
    }, [message, erreur]);

    useEffect(() => {
        if (message && !erreur) {
            retourRatelier();
        }
    }, [message]);

    useEffect(() => {
        reinitialiserStore();

        // Requete pour recuperer les informations des armes
        if (location.state.listeArme) {
            const data = { listeArmesUuid: location.state.listeArme };

            postApi(
                usagerClientReducer,
                API_DECLARATION_ARME_PERDUE_VOLEE_RECUPERER_URL,
                data,
                CONTEXT_DECLARATION_ARME_PERDUE_VOLEE_RECUPERER,
            );
        }

        if (!dataProfil) {
            retourRatelier();
        }
    }, []);

    const validateDateJustificatif = (value) => {
        const dateDecoupee = value.split('/');

        if (
            new Date(dateDecoupee[2], dateDecoupee[1] - 1, dateDecoupee[0]).getTime() >
            new Date().getTime()
        ) {
            return 'Date non valide, veuillez renseigner une date valide';
        }

        return null;
    };

    return (
        dataProfil && (
            <Container fluid={false}>
                {isLoadingListeArme || !dataListeArme ? (
                    <LoaderMi taille="lg" />
                ) : (
                    <Row>
                        <Col>
                            <p>
                                Nombre d&apos;arme(s) perdue(s) / volée(s) :{' '}
                                {listeArmesDeclarationPerduesVolees.length} arme(s) sélectionnée(s)
                            </p>
                        </Col>
                    </Row>
                )}
                <FormProvider {...hookForm}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        {!isLoadingListeArme && dataListeArme && (
                            <Row>
                                <Col>
                                    <TableauArmePerdueVolee
                                        donnees={listeArmesDeclarationPerduesVolees.map(
                                            (element, index) => {
                                                const ligne = { ...element };
                                                delete ligne.uniquid;
                                                ligne.action =
                                                    listeArmesDeclarationPerduesVolees.length > 1
                                                        ? getBoutonAction(index)
                                                        : null;

                                                return ligne;
                                            },
                                        )}
                                    />
                                </Col>
                            </Row>
                        )}
                        <Row>
                            <Col>
                                <FieldsetControl
                                    id="stepSignalerBlocUn"
                                    legend="Si vous avez perdu ou que vous vous êtes fait voler une arme
                                            ou un élément d'arme des catégories A, B, ou C vous devez immédiatement faire
                                            une déclaration au commissariat de police ou à la brigade de gendarmerie"
                                    hintText="Ne pas respecter cette règle est passible d'une amende de 750 euros.
                                            Article R. 317-2 du code de la sécurité intérieure"
                                >
                                    <> </>
                                </FieldsetControl>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FieldsetControl legend="Où s'adresser ?" id="stepSignalerBlocDeux">
                                    <Link
                                        title="Ministère de l'intérieur - Contact Gendarmerie Police"
                                        href={REACT_APP_CONTACT_GENDARMERIE_POLICE_URL}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Contacter une brigade de gendarmerie ou un commissariat de
                                        police
                                    </Link>
                                </FieldsetControl>
                            </Col>
                        </Row>
                        <Row>
                            <Col col={12}>
                                <InfoChampsObligatoire />
                            </Col>
                        </Row>

                        <Row gutters>
                            <Col col={6}>
                                <FieldsetControl
                                    legend="Situation :"
                                    inline
                                    id="stepSignalerBlocTrois"
                                >
                                    <RadioControl
                                        id={useId()}
                                        label="Perdue"
                                        value="perte"
                                        {...register('situation')}
                                    />
                                    <RadioControl
                                        id={useId()}
                                        label="Volée"
                                        value="vol"
                                        {...register('situation')}
                                    />
                                </FieldsetControl>
                            </Col>
                            <Col col={6}>
                                <Row>
                                    <Col>
                                        <p>
                                            Date et lieu du récépissé de déclaration de perte ou de
                                            vol*
                                        </p>
                                    </Col>
                                </Row>
                                <Row gutters>
                                    <Col col={6}>
                                        <InputControl
                                            name="dateRecepisseDeclaration"
                                            id="dateRecepisseDeclaration"
                                            label="Le:"
                                            type="text"
                                            uppercase
                                            {...register('dateRecepisseDeclaration', {
                                                required: true,
                                                pattern: getPatternHookFormValidation(
                                                    REGEXP_DATE_FR,
                                                    '',
                                                    MESSAGE_DATE_NAISSANCE_INVALIDE,
                                                ),
                                                validate: (value) =>
                                                    validateDateJustificatif(value),
                                            })}
                                            placeholder="JJ/MM/AAAA"
                                            maskFonction={getDateFormatWithSlash}
                                        />
                                    </Col>
                                    <Col col={6}>
                                        <InputControl
                                            id="lieuRecepisseDeclaration"
                                            name="lieuRecepisseDeclaration"
                                            label="A:"
                                            type="text"
                                            maxLength="60"
                                            uppercase
                                            {...register('lieuRecepisseDeclaration', {
                                                required: getMessageErreurChampManquant('Lieu'),
                                            })}
                                            placeholder="Lieu"
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        <Row gutters>
                            <Col>
                                <InputFiles
                                    name="justificatif"
                                    label='Un récépissé de déclaration de perte ou de vol vous est alors remis, cliquer sur le bouton "Importer" pour importer le document'
                                    required
                                    error={formState.errors ? formState.errors.justificatif : null}
                                    accept=".png,.pdf,.jpeg,.jpg"
                                    texteAide="La taille maximale autorisée de votre document est 5Mo. Les formats acceptés sont .pdf, .png, .jpg, .jpeg"
                                />
                            </Col>
                        </Row>
                        <Row gutters>
                            <Col> </Col>
                        </Row>
                        <Row gutters className="margin-top-md">
                            <Col>
                                <CheckboxControl
                                    id="certificationInformations"
                                    name="certificationInformations"
                                    label={`Je soussigné ${dataProfil.prenom} ${dataProfil.nom}, certifie l'exactitude des renseignements fournis *`}
                                    value
                                    required
                                    {...register('certificationInformation', {
                                        required: getMessageErreurChampManquant('Certifie'),
                                    })}
                                />
                            </Col>
                        </Row>
                        <Row gutters>
                            <Col> </Col>
                        </Row>
                        <Row gutters className="margin-top-lg">
                            <Col lg={6}>
                                <Button onClick={retourRatelier} variant="secondary">
                                    Retour
                                </Button>
                            </Col>
                            <Col lg={6} className="text-right">
                                <Button
                                    variant="primary"
                                    type="submit"
                                    disabled={!hasFormValid() || isSubmitting}
                                    isLoading={isLoading || isSubmitting}
                                >
                                    Valider
                                </Button>
                            </Col>
                        </Row>
                    </form>
                </FormProvider>
            </Container>
        )
    );
};

FormulaireArmePerdueVolee.propTypes = {
    postApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    message: PropTypes.string,
    erreur: PropTypes.bool,
    dataProfil: PropTypes.array,
    isLoadingListeArme: PropTypes.bool,
    dataListeArme: PropTypes.array,
};

export default connect(
    (state) => {
        const { data } = state.profil.usager;
        const { message, isLoading, erreur } = state.armes.signalerArmePerdueVolee.reponse;
        const { isLoading: isLoadingListeArme, data: dataListeArme } =
            state.armes.signalerArmePerdueVolee.recuperer;
        return {
            dataProfil: data,
            message,
            erreur,
            isLoading,
            isLoadingListeArme,
            dataListeArme,
        };
    },
    {
        postApi: postAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(FormulaireArmePerdueVolee);
